import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ProcessLoader } from '@/common/components';
import { GENETIC_COUNSELING_TRANSLATION } from '@/modules/genetic-counseling/constants';
import { ReopenProps } from './Reopen.types';
import { StyledButtonContainer, StyledContainer, StyledContent, StyledMoved, StyledReopen } from './Reopen.styles';
import { Variants } from '@/common/types';

const Reopen: FC<ReopenProps> = ({ handleCancel, handleConfirm, isLoading }) => {
  const { t } = useTranslation(GENETIC_COUNSELING_TRANSLATION);

  return (
    <StyledContainer data-testid={'reopen'}>
      {isLoading ? (
        <StyledContent data-testid={'reopen-content-loading'}>
          <ProcessLoader title={t('reopen.message_reopen')} description={t('reopen.message_loading')} />
        </StyledContent>
      ) : (
        <StyledContent data-testid={'reopen-content'}>
          <StyledReopen data-testid={'reopen-message'}>{t('reopen.message')}</StyledReopen>
          <StyledMoved data-testid={'reopen-moved'}>{t('reopen.message_moved')}</StyledMoved>
          <StyledButtonContainer>
            <Button data-testid={'reopen-button-confirm'} onClick={handleConfirm}>
              {t('reopen.confirm')}
            </Button>
            <Button data-testid={'reopen-button-cancel'} variant={Variants.TERTIARY} onClick={handleCancel}>
              {t('reopen.cancel')}
            </Button>
          </StyledButtonContainer>
        </StyledContent>
      )}
    </StyledContainer>
  );
};

export default Reopen;
